import classnames from 'classnames/bind'
import { Swiper, SwiperSlide } from 'swiper/react'
import { useTranslation } from 'next-i18next'

// Libs

// Components

// Constants

// Styles
import styles from './style.module.scss'

// Mock Data

const cx = classnames.bind(styles)

interface TabProps {
  values: { role?: number; label: string; value: any }[]
  onChange: (amount: any) => void
  className?: string
  activeIndex?: number | undefined
}

const ColorfulTab = ({ values, onChange, className, activeIndex }: TabProps) => {
  const { t } = useTranslation()
  const handleChange = (value: any) => {
    onChange(value)
  }

  return (
    <div className={cx('tabs', className)}>
      <Swiper className={cx('tabs__carousell')} slidesPerView='auto' spaceBetween={20} slideToClickedSlide grabCursor>
        {values.map((data, index) => (
          <SwiperSlide key={index} style={{ width: 'auto' }}>
            <div className={cx('tabs-tab', { active: index === activeIndex })} onClick={() => handleChange(data.value)}>
              {t(data.label)}
              {<div className={cx('tabs-tab-underline', { active: index === activeIndex })} />}
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  )
}

export default ColorfulTab
